module.exports = __webpack_public_path__ + "media/images/logos/bft-logo-c538e3684483b3db8e4c93d5661b8fa3.svg";